import React from 'react';
import { Chip } from '@mui/material';
import './TaskInfo.css';
import moment from 'moment';

const TaskInfo = (props) => {
    let { is_active } = props;
    return (
        <div className="taskItem" style={{ padding: '8px 4px', borderBottom: '1px solid #f2f5f9' }}>
            <div className="taskHeading" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <span style={{ fontSize: '0.84rem', fontWeight: 600, color: '#1a2a4a' }}>{props.name}</span>
                <span style={{ fontSize: '0.74rem', color: '#999' }}>{moment(props.start_date.replace(/Z/g, '')).format('D MMM YYYY')} – {moment(props.end_date.replace(/Z/g, '')).format('D MMM YYYY')}</span>
            </div>
            {(is_active === 1) &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.76rem', color: '#999' }}>{props.momentCode && props.momentCode.CheckoutTime.fromNow()}</span>
                    <Chip size="small" label="Completed" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 600, fontSize: '0.7rem' }} />
                </div>
            }
            {(moment(new Date()).isBetween(props.start_date, moment(props.end_date).add(1, 'days')) && is_active === 0) &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.76rem', color: '#999' }}>{!props.momentCode ? `for ${moment.duration((moment(props.end_date).add(1, 'd')).diff(moment())).humanize()}` : `checked-in ${moment.duration(moment(props.momentCode.CheckInTime).diff(moment())).humanize()} ago`}</span>
                    <Chip size="small" label="In Progress" sx={{ bgcolor: '#e3f2fd', color: '#1565c0', fontWeight: 600, fontSize: '0.7rem' }} />
                </div>
            }
            {(moment(new Date()).isAfter(moment(props.end_date).add(1, 'd')) && is_active === 0) &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.76rem', color: '#999' }}>{moment(props.end_date.replace(/Z/g, '')).fromNow()}</span>
                    <Chip size="small" label="Overdue" sx={{ bgcolor: '#fff3e0', color: '#e65100', fontWeight: 600, fontSize: '0.7rem' }} />
                </div>
            }
            {(moment(props.start_date).isAfter(new Date()) && is_active === 0) &&
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.76rem', color: '#999' }}>{moment().to(moment(props.end_date.replace(/Z/g, '')))}</span>
                    <Chip size="small" label="Scheduled" sx={{ bgcolor: '#fff3e0', color: '#e65100', fontWeight: 600, fontSize: '0.7rem' }} />
                </div>
            }
        </div>
    );
};

export default TaskInfo;
